
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <p className="text-gray-400 mb-4">
              Sua presença profissional começa aqui.
            </p>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">Links Rápidos</h3>
            <div className="space-y-2">
              <Link to="/resultados" className="block text-gray-400 hover:text-white transition-colors">
                Resultados
              </Link>
              <Link to="/trajetoria" className="block text-gray-400 hover:text-white transition-colors">
                Trajetória
              </Link>
              <Link to="/como-funciona" className="block text-gray-400 hover:text-white transition-colors">
                Como Funciona
              </Link>
              <Link to="/contato" className="block text-gray-400 hover:text-white transition-colors">
                Contato
              </Link>
            </div>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">Contato</h3>
            <div className="space-y-2 text-gray-400">
              <p>contato@setedeouros.com.br</p>
              <p>(44) 98804-7699</p>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-gray-400">
              <p>7 DE OUROS LTDA</p>
              <p>CNPJ: 55.902.450/0001-61</p>
            </div>
            <div className="flex space-x-6 text-sm text-gray-400">
              <Link to="/politica-privacidade" className="hover:text-white transition-colors">
                Política de Privacidade
              </Link>
              <Link to="/termos-uso" className="hover:text-white transition-colors">
                Termos de Uso
              </Link>
            </div>
          </div>
          <div className="mt-4 text-sm text-gray-500 text-center">
            <p>300+ empresas atendidas - Entrega em 10 dias - IA integrada.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
